












import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import AdvanceSearchComponent from "@/components/common/AdvanceFilter/AdvanceSearch.vue";
import ListItem from "@/components/App/Modules/GMS/Dashboard/components/ListItem.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import { ReportFilter, ReportParameter } from "@/entities";

const namespace: string = "Dashboard";

@Component({ components: { ListItem, AdvanceSearchComponent } })
export default class PendingActionComponent extends Vue {
  @Prop() readonly filters!: any;
  @Prop() readonly items!: any;

  sections: any = [
    { text: "All", value: "All" },
    { text: "Application", value: "Application" },
    { text: "Financial Report", value: "FinancialReport" },
    { text: "Technical Report", value: "TechnicalReport" },
  ];

  fields: Array<ReportFilter> = [];
  selectedParams: Array<ReportParameter> = [];

  mounted() {}

  onSearch(selValue) {
    this.$emit("search", this.selectedParams);
  }
}
